var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagWithCountryCode(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 32,
    viewBox: "0 0 65 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.362305,
    y: 0.015625,
    width: 63.9553,
    height: 31,
    rx: 3.32143,
    fill: "#E9EAEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4592 16.1815H41.0352V18.6655H39.7632V16.1815H37.3392V15.0295H39.7632V12.5455H41.0352V15.0295H43.4592V16.1815ZM47.1056 17.5615C47.1856 17.9615 47.3576 18.2655 47.6216 18.4735C47.8856 18.6815 48.2416 18.7855 48.6896 18.7855C49.2576 18.7855 49.6736 18.5615 49.9376 18.1135C50.2016 17.6655 50.3336 16.9015 50.3336 15.8215C50.1416 16.0935 49.8696 16.3055 49.5176 16.4575C49.1736 16.6015 48.7976 16.6735 48.3896 16.6735C47.8696 16.6735 47.3976 16.5695 46.9736 16.3615C46.5496 16.1455 46.2136 15.8295 45.9656 15.4135C45.7256 14.9895 45.6056 14.4775 45.6056 13.8775C45.6056 12.9975 45.8616 12.2975 46.3736 11.7775C46.8936 11.2495 47.6056 10.9855 48.5096 10.9855C49.5976 10.9855 50.3696 11.3495 50.8256 12.0775C51.2896 12.7975 51.5216 13.9055 51.5216 15.4015C51.5216 16.4335 51.4336 17.2775 51.2576 17.9335C51.0896 18.5895 50.7936 19.0855 50.3696 19.4215C49.9456 19.7575 49.3576 19.9255 48.6056 19.9255C47.7496 19.9255 47.0896 19.7015 46.6256 19.2535C46.1616 18.8055 45.9016 18.2415 45.8456 17.5615H47.1056ZM48.6296 15.5215C49.1096 15.5215 49.4856 15.3735 49.7576 15.0775C50.0376 14.7735 50.1776 14.3735 50.1776 13.8775C50.1776 13.3255 50.0296 12.8975 49.7336 12.5935C49.4456 12.2815 49.0496 12.1255 48.5456 12.1255C48.0416 12.1255 47.6416 12.2855 47.3456 12.6055C47.0576 12.9175 46.9136 13.3295 46.9136 13.8415C46.9136 14.3295 47.0536 14.7335 47.3336 15.0535C47.6216 15.3655 48.0536 15.5215 48.6296 15.5215ZM52.8388 12.4375V11.1895H55.3348V19.9375H53.9548V12.4375H52.8388Z",
    fill: "#111D31"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24165_39527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68359 6.65625H31.3179V12.5648H7.68359V6.65625Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68359 12.5625H31.3179V18.4711H7.68359V12.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68359 18.4766H31.3179V24.3851H7.68359V18.4766Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5011 17.8831C20.8064 17.8831 21.8646 16.825 21.8646 15.5197C21.8646 14.2144 20.8064 13.1562 19.5011 13.1562C18.1958 13.1562 17.1377 14.2144 17.1377 15.5197C17.1377 16.825 18.1958 17.8831 19.5011 17.8831Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5006 17.5891C20.6427 17.5891 21.5686 16.6632 21.5686 15.5211C21.5686 14.379 20.6427 13.4531 19.5006 13.4531C18.3585 13.4531 17.4326 14.379 17.4326 15.5211C17.4326 16.6632 18.3585 17.5891 19.5006 17.5891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5005 15.9366C19.7289 15.9366 19.9141 15.7514 19.9141 15.523C19.9141 15.2945 19.7289 15.1094 19.5005 15.1094C19.2721 15.1094 19.0869 15.2945 19.0869 15.523C19.0869 15.7514 19.2721 15.9366 19.5005 15.9366Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5367 15.8966C21.5949 15.9043 21.6483 15.8633 21.656 15.8051C21.6637 15.7468 21.6227 15.6934 21.5644 15.6858C21.5062 15.6781 21.4528 15.7191 21.4451 15.7773C21.4374 15.8356 21.4784 15.889 21.5367 15.8966Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5006 17.5895L19.5715 16.3487L19.5006 15.7578L19.4297 16.3487L19.5006 17.5895Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3704 16.4091C21.4246 16.4316 21.4869 16.4058 21.5093 16.3515C21.5318 16.2973 21.506 16.2351 21.4518 16.2126C21.3975 16.1901 21.3353 16.2159 21.3128 16.2701C21.2903 16.3244 21.3161 16.3866 21.3704 16.4091Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9655 17.5142L19.3551 16.334L19.4396 15.7449L19.2182 16.2973L18.9655 17.5142Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.077 16.8663C21.1236 16.9021 21.1903 16.8933 21.2261 16.8467C21.2618 16.8001 21.253 16.7333 21.2064 16.6976C21.1598 16.6618 21.0931 16.6706 21.0573 16.7172C21.0216 16.7638 21.0304 16.8306 21.077 16.8663Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4678 17.3092L19.1496 16.2701L19.3837 15.723L19.0268 16.1992L18.4678 17.3092Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6743 17.2295C20.7101 17.2761 20.7768 17.2849 20.8234 17.2491C20.87 17.2134 20.8788 17.1466 20.8431 17.1C20.8073 17.0534 20.7405 17.0446 20.6939 17.0804C20.6473 17.1161 20.6386 17.1829 20.6743 17.2295Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0382 16.9859L18.9657 16.1587L19.3333 15.6908L18.8654 16.0584L18.0382 16.9859Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1928 17.4765C20.2153 17.5308 20.2775 17.5566 20.3318 17.5341C20.386 17.5116 20.4118 17.4494 20.3893 17.3951C20.3669 17.3409 20.3046 17.3151 20.2504 17.3376C20.1961 17.3601 20.1703 17.4223 20.1928 17.4765Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.709 16.5554L18.819 15.9964L19.2952 15.6395L18.7481 15.8736L17.709 16.5554Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6643 17.5863C19.672 17.6446 19.7254 17.6856 19.7836 17.6779C19.8419 17.6702 19.8829 17.6168 19.8752 17.5586C19.8675 17.5003 19.8141 17.4593 19.7559 17.467C19.6976 17.4747 19.6567 17.5281 19.6643 17.5863Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.503 16.0582L18.7199 15.8055L19.2723 15.5841L18.6832 15.6686L17.503 16.0582Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1229 17.5542C19.1152 17.6125 19.1562 17.6659 19.2144 17.6736C19.2727 17.6812 19.3261 17.6402 19.3338 17.582C19.3414 17.5238 19.3004 17.4703 19.2422 17.4627C19.184 17.455 19.1306 17.496 19.1229 17.5542Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.431 15.5162L18.6718 15.5871L19.2627 15.5162L18.6718 15.4453L17.431 15.5162Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6085 17.384C18.586 17.4383 18.6118 17.5005 18.666 17.523C18.7203 17.5455 18.7825 17.5197 18.805 17.4654C18.8275 17.4112 18.8017 17.349 18.7474 17.3265C18.6932 17.304 18.631 17.3298 18.6085 17.384Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5015 14.9772L18.6816 15.3669L19.2707 15.4513L18.7183 15.2299L17.5015 14.9772Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1571 17.1033C18.1214 17.1499 18.1302 17.2167 18.1768 17.2524C18.2234 17.2882 18.2901 17.2794 18.3259 17.2328C18.3616 17.1862 18.3528 17.1195 18.3062 17.0837C18.2596 17.0479 18.1929 17.0567 18.1571 17.1033Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7093 14.4971L18.7485 15.1789L19.2956 15.413L18.8194 15.0561L17.7093 14.4971Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7949 16.7007C17.7483 16.7364 17.7395 16.8032 17.7753 16.8498C17.811 16.8964 17.8778 16.9052 17.9244 16.8694C17.971 16.8337 17.9798 16.7669 17.944 16.7203C17.9083 16.6737 17.8415 16.6649 17.7949 16.7007Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0375 14.0596L18.8647 14.9872L19.3327 15.3548L18.965 14.8869L18.0375 14.0596Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5459 16.227C17.4917 16.2495 17.4659 16.3117 17.4884 16.366C17.5108 16.4202 17.5731 16.446 17.6273 16.4235C17.6816 16.401 17.7074 16.3388 17.6849 16.2846C17.6624 16.2303 17.6002 16.2045 17.5459 16.227Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4642 13.7461L19.0232 14.8561L19.38 15.3323L19.146 14.7852L18.4642 13.7461Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4332 15.6936C17.375 15.7013 17.334 15.7547 17.3416 15.8129C17.3493 15.8712 17.4027 15.9122 17.461 15.9045C17.5192 15.8968 17.5602 15.8434 17.5525 15.7852C17.5449 15.7269 17.4914 15.686 17.4332 15.6936Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9633 13.5382L19.216 14.755L19.4374 15.3074L19.3529 14.7183L18.9633 13.5382Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4653 15.1424C17.4071 15.1347 17.3536 15.1757 17.346 15.234C17.3383 15.2922 17.3793 15.3456 17.4375 15.3533C17.4958 15.361 17.5492 15.32 17.5569 15.2617C17.5645 15.2035 17.5235 15.1501 17.4653 15.1424Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5014 13.4496L19.4305 14.6904L19.5014 15.2812L19.5723 14.6904L19.5014 13.4496Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6316 14.63C17.5773 14.6075 17.5151 14.6333 17.4926 14.6875C17.4701 14.7418 17.4959 14.804 17.5502 14.8265C17.6044 14.849 17.6667 14.8232 17.6891 14.7689C17.7116 14.7147 17.6858 14.6524 17.6316 14.63Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0364 13.5249L19.6468 14.7051L19.5624 15.2941L19.7838 14.7418L20.0364 13.5249Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.925 14.1728C17.8784 14.137 17.8116 14.1458 17.7759 14.1924C17.7401 14.239 17.7489 14.3057 17.7955 14.3415C17.8421 14.3773 17.9089 14.3685 17.9446 14.3219C17.9804 14.2753 17.9716 14.2085 17.925 14.1728Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5351 13.7299L19.8533 14.769L19.6193 15.3161L19.9761 14.8399L20.5351 13.7299Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3276 13.8096C18.2919 13.763 18.2251 13.7542 18.1785 13.7899C18.1319 13.8257 18.1231 13.8925 18.1589 13.9391C18.1946 13.9857 18.2614 13.9945 18.308 13.9587C18.3546 13.9229 18.3634 13.8562 18.3276 13.8096Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9638 14.0531L20.0363 14.8804L19.6686 15.3483L20.1365 14.9806L20.9638 14.0531Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8082 13.5703C18.7857 13.5161 18.7235 13.4903 18.6692 13.5128C18.6149 13.5353 18.5892 13.5975 18.6116 13.6517C18.6341 13.706 18.6963 13.7318 18.7506 13.7093C18.8049 13.6868 18.8306 13.6246 18.8082 13.5703Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.292 14.4915L20.182 15.0505L19.7058 15.4073L20.2529 15.1733L21.292 14.4915Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3367 13.4527C19.329 13.3945 19.2756 13.3535 19.2173 13.3612C19.1591 13.3688 19.1181 13.4223 19.1258 13.4805C19.1334 13.5387 19.1869 13.5797 19.2451 13.5721C19.3033 13.5644 19.3443 13.511 19.3367 13.4527Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.498 14.9809L20.2811 15.2335L19.7287 15.455L20.3178 15.3705L21.498 14.9809Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8781 13.4848C19.8858 13.4266 19.8448 13.3732 19.7865 13.3655C19.7283 13.3578 19.6749 13.3988 19.6672 13.4571C19.6595 13.5153 19.7005 13.5687 19.7588 13.5764C19.817 13.584 19.8704 13.5431 19.8781 13.4848Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5699 15.5228L20.3291 15.4519L19.7383 15.5228L20.3291 15.5938L21.5699 15.5228Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3925 13.655C20.415 13.6007 20.3892 13.5385 20.3349 13.5161C20.2807 13.4936 20.2185 13.5193 20.196 13.5736C20.1735 13.6279 20.1993 13.6901 20.2535 13.7126C20.3078 13.7351 20.37 13.7093 20.3925 13.655Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 16.0618L20.3193 15.6722L19.7303 15.5878L20.2826 15.8092L21.4995 16.0618Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8438 13.9514C20.8796 13.9048 20.8708 13.838 20.8242 13.8022C20.7776 13.7665 20.7109 13.7753 20.6751 13.8219C20.6393 13.8685 20.6481 13.9352 20.6947 13.971C20.7413 14.0068 20.8081 13.998 20.8438 13.9514Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2907 16.5575L20.2515 15.8757L19.7044 15.6417L20.1806 15.9986L21.2907 16.5575Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2051 14.354C21.2517 14.3183 21.2605 14.2515 21.2247 14.2049C21.189 14.1583 21.1222 14.1495 21.0756 14.1853C21.029 14.221 21.0202 14.2878 21.056 14.3344C21.0917 14.381 21.1585 14.3898 21.2051 14.354Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9625 16.995L20.1353 16.0675L19.6673 15.6999L20.035 16.1678L20.9625 16.995Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4531 14.8277C21.5074 14.8052 21.5331 14.743 21.5107 14.6887C21.4882 14.6345 21.426 14.6087 21.3717 14.6312C21.3174 14.6537 21.2917 14.7159 21.3141 14.7701C21.3366 14.8244 21.3988 14.8502 21.4531 14.8277Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5348 17.3086L19.9759 16.1986L19.619 15.7224L19.853 16.2695L20.5348 17.3086Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5658 15.3611C21.6241 15.3534 21.6651 15.3 21.6574 15.2417C21.6497 15.1835 21.5963 15.1425 21.5381 15.1502C21.4798 15.1578 21.4388 15.2113 21.4465 15.2695C21.4542 15.3277 21.5076 15.3687 21.5658 15.3611Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0357 17.5165L19.7831 16.2996L19.5617 15.7473L19.6461 16.3363L20.0357 17.5165Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24165_39527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6343,
    height: 17.7257,
    fill: "white",
    transform: "translate(7.68359 6.65625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagWithCountryCode);
export default __webpack_public_path__ + "static/media/FlagWithCountryCode.f01c005f99fef85ab6d561c894e1fe35.svg";
export { ForwardRef as ReactComponent };